import axios from 'axios'
import Cookies from 'universal-cookie'
import { CleanJsonData, ClearCookies } from '../Utilities/Utilities.js'
import { API_BASE_URL } from '../config.js';
import { persistor } from '../Redux/store';


// Constants
const data = {
    user: { success: false, message: null, client: null, identifier: null },
    listUser: { success: false, message: null, list: [] }
}

const LOG_IN_USER = 'LOG_IN_USER'
const GET_USER_LIST_SUCCESS = 'GET_USER_LIST_SUCCESS'

// reducer
export default function userReducer(state = data, action) {
    switch (action.type) {
        case LOG_IN_USER:
            return { ...state, user: action.payload, identifier: action.payload.identifier }
        case GET_USER_LIST_SUCCESS:
            return { ...state, listUser: action.payload }
        default:
            return state
    }
}

export const getConsultantIdentifier = () => {
    const cookies = new Cookies();
    return cookies.get('identifier') || null;
};

export const getConsultantId = () => {
    const cookies = new Cookies();
    return cookies.get('userId') || null;
};


export const LoginUser = (DATA) => async (dispatch) => {
    const cookies = new Cookies();
    // Limpiar cookies anteriores
    ClearCookies(cookies)
    // Limpiar datos de entrada
    DATA = CleanJsonData(DATA);

    //Object.keys(localStorage)
    //    .filter((key) => key.startsWith('persist:'))
    //    .forEach((key) => localStorage.removeItem(key));
    localStorage.clear();
    sessionStorage.clear();
    await persistor.purge();


    dispatch({
        type: LOG_IN_USER,
        payload: { success: false, message: window.messagesAxios.loginStart, user: null, identifier: null, start: true }
    });

    try {
        const response = await axios.post(`${API_BASE_URL}/User/login`, DATA)

        console.log("response", response)

        if (response.status === 200) {

            const data = response.data;
            /*if (window.MARCHA_BLANCA == null || window.MARCHA_BLANCA == undefined) {
                alert("no autorizado en marcha blanca.")
                return;
            }
            else if (!window.MARCHA_BLANCA.includes(data.userId)) {
                alert("no autorizado en marcha blanca...")
                return
            }*/
            
            for (let key in data) {
                if (data.hasOwnProperty(key)) {
                    const cookieKey = key === "token" ? "tokenGcc" : key;
                    cookies.set(cookieKey, data[key], { path: "/" });
                }
            }

            dispatch({
                type: LOG_IN_USER,
                payload: {
                    success: true,
                    message: window.messagesAxios.loginSuccess,
                    user: {
                        id: data.userId,
                        rolId: data.rolId,
                        username: data.userName,
                        expirationTime: data.expirationTime,
                        identifier: data.identifier
                    },
                    identifier: data.identifier  // Add this line

                }
            })
        } else
            ClearCookies(cookies)
    } catch (error) {
        let errorMessage = window.messagesAxios.loginError;
        if (error.response && error.response.status === 401) {
            errorMessage = "Credenciales inválidas";
        }
        dispatch({
            type: LOG_IN_USER,
            payload: { success: false, message: errorMessage, user: null }
        })
        ClearCookies(cookies)
    }
}



export const LogoutUser = () => async (dispatch, getState) => {
    const cookies = new Cookies();
    ClearCookies(cookies)
    // limpiar local storage

    localStorage.clear();
    sessionStorage.clear();
    await persistor.purge();

    dispatch({
        type: LOG_IN_USER,
        payload: { success: false, message: window.messagesAxios.logout, user: null }
    })

    setTimeout(() => {
        window.location.reload();
    }, 300)
}



export const GetListUsers = (DATA) => async (dispatch, getState) => {

    const cookies = new Cookies()
    DATA = CleanJsonData(DATA)

    dispatch({
        type: GET_USER_LIST_SUCCESS,
        payload: { success: false, message: window.messagesAxios.getListUsersStart, list: [] }
    })

    try { // nombre rut telefono direccion
        const RES = await axios.post(window.API_ALLUSER, null, { headers: { 'Authorization': `Bearer ${cookies.get('tokenGcc')}` } })
        if (RES.status === 200) {
            dispatch({
                type: GET_USER_LIST_SUCCESS,
                payload: { success: false, message: window.messagesAxios.getListUsersSuccess, list: RES.data }
            })
        }
        else {
            dispatch({
                type: GET_USER_LIST_SUCCESS,
                payload: { success: false, message: window.messagesAxios.getListUsersError, list: [] }
            })
        }

    } catch (error) {
        if (error.response.status === 404) {
            dispatch({
                type: GET_USER_LIST_SUCCESS,
                payload: { success: false, message: error.response.data, list: [] }
            })
        }
        else {
            dispatch({
                type: GET_USER_LIST_SUCCESS,
                payload: { success: false, message: window.messagesAxios.getListUsersError, user: null }
            })
        }
    }
}